/**
 * Ajax Search Lite — Accessible Label
 *
 * Le plugin Ajax Search Lite ne génère qu'un `aria-label` sur son champ,
 * sans <label> réellement associé (id/for). Pour la conformité RGAA
 * (critère 11.1), on injecte un <label> visuellement masqué (.sr-only)
 * et correctement lié via for/id, sur chaque instance du widget présente
 * dans la page.
 */

const LABEL_TEXT = 'Rechercher sur le site';

function labelInput(input, index) {
    if (input.dataset.hfLabelled) {
        return;
    }

    if (!input.id) {
        input.id = `asl-search-input-${index}`;
    }

    const label = document.createElement('label');
    label.setAttribute('for', input.id);
    label.classList.add('sr-only');
    label.textContent = LABEL_TEXT;

    input.closest('.proinput').prepend(label);
    input.dataset.hfLabelled = 'true';
}

export function initAjaxSearchLiteLabel() {
    const inputs = document.querySelectorAll('.probox .proinput input.orig');

    if (!inputs.length) {
        return;
    }

    inputs.forEach(labelInput);
}
